import { useTranslation } from 'react-i18next';
import { Button } from '@resideo/blueprint-oneportal';
import styles from './RemoveLocationConfirmModal.module.css';

export interface RemoveLocationConfirmModalProps {
  locationName: string;
  userName: string;
  isRemoving: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function RemoveLocationConfirmModal({
  locationName,
  userName,
  isRemoving,
  onConfirm,
  onCancel,
}: RemoveLocationConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <p className={styles.title}>{t('removeLocationModal.title', { locationName })}</p>
        <p className={styles.body}>{t('removeLocationModal.body', { userName })}</p>
        <div className={styles.actions}>
          <Button variant="highlightTertiary" onClick={onCancel} disabled={isRemoving} style={{ fontWeight: 700 }}>
            {t('employees.resendInviteCancel')}
          </Button>
          <Button variant="destructivePrimary" onClick={onConfirm} disabled={isRemoving} style={{ fontWeight: 700 }}>
            {isRemoving ? t('removeLocationModal.removing') : t('removeLocationModal.confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
}
